import { Bell, Boxes, ClipboardList, FileText, House, Layers, type LucideIcon, Package, RefreshCw, Settings, ShoppingCart, Tags, Truck, Wrench } from "lucide-react";

/**
 * Icons by name, for tool metadata (ToolMeta.icon). Only the icons listed here are bundled:
 * add one here when a tool needs it.
 */
const ICONS: Record<string, LucideIcon> = { Bell, Boxes, ClipboardList, FileText, House, Layers, Package, RefreshCw, Settings, ShoppingCart, Tags, Truck, Wrench };

export function Icon({ name, className }: Readonly<{ name: string; className?: string }>) {
    const Component = ICONS[name] ?? Wrench;
    return <Component className={className} />;
}
